import { ErrorResolution } from '../../../app/common/errorResolution/errorResolution';

export enum RevokeSessionActionTypes {
    SEND_SESSION_REVOKE_REQUEST = 'SEND_SESSION_REVOKE_REQUEST',
    SEND_SESSION_REVOKE_SUCCESS = 'SEND_SESSION_REVOKE_SUCCESS',
    SEND_SESSION_REVOKE_FAILURE = 'SEND_SESSION_REVOKE_FAILURE',
    SET_SESSION_REVOKE = 'SET_SESSION_REVOKE',
}

export type RevokeSessionAction =
    | {
          type: RevokeSessionActionTypes.SEND_SESSION_REVOKE_REQUEST;
      }
    | {
          type: RevokeSessionActionTypes.SEND_SESSION_REVOKE_SUCCESS;
      }
    | {
          type: RevokeSessionActionTypes.SEND_SESSION_REVOKE_FAILURE;
          payload: { errorResolution: ErrorResolution };
      }
    | {
          type: RevokeSessionActionTypes.SET_SESSION_REVOKE;
          payload: boolean;
      };
